export const DATEPICKER_CONFIG = {
  dateInputFormat: 'DD.MM.YYYY',
  rangeInputFormat: 'DD.MM.YYYY',
  rangeSeparator: ' - ',
  containerClass: 'theme-blue',
  isAnimated: true,
  adaptivePosition: true,
  daysDisabled: [0, 6],
  locale: 'en-gb'
};
